interface StepProps {
    title: string;
    subTitle: string;
    tagText: string | undefined;
    color: string;
    isActive: boolean;
    isDisabled: boolean;
}

const Step = ({ title, subTitle, tagText, color, isActive, isDisabled }: StepProps) => {
    return (
        <div className="pb-6 relative right-pole-grey flex justify-between">
            <div className="">
                <p className="text-gray-900 whitespace-no-wrap text-base capitalize">
                    <span
                        className={`w-2.5 h-2.5 rounded-full inline-block mr-2 border-2 relative z-10 ${isDisabled ? 'bg-gray-400 border-gray-400' : ''}`}
                        style={{ backgroundColor: isActive ? color : '#fff', borderColor: color }}
                    />
                    {title}
                </p>
                <p className="text-gray-500 whitespace-no-wrap text-sm capitalize">
                    <span className="w-2.5 h-2.5 rounded-full inline-block mr-2"></span>
                    {subTitle}
                </p>
            </div>
            <div className="text-gray-500 whitespace-no-wrap text-xs capitalize mt-1">{tagText}</div>
        </div>
    );
};

export default Step;
